import { useState } from "react"
import { useCookies } from "react-cookie"
import PropTypes from "prop-types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import "./pro_diy_footer.scss"
import { ProDIYBannerAndFooterCopies } from "./utils/pro_diy_banner_copies"

const ProDiyFooter = ({ cookieName, onClick, urls, userTier }) => {
  const [cookies, setCookie] = useCookies([cookieName])
  const [hideFooter, setHideFooter] = useState(cookies[cookieName])

  if (hideFooter) {
    return null
  }

  const onHide = () => {
    logIFTTTNextAction("click", {
      object_type: "maybe_later_button",
      location_type: "diy_composer",
    })
    setCookie(cookieName, true)
    setHideFooter(true)
  }

  let bannerTitle = ProDIYBannerAndFooterCopies.title
  let buttonLabel = ProDIYBannerAndFooterCopies.buttonLabel
  let url = urls.newProSubscriptionUrl
  let handleOnClick

  if (userTier === "intermediate_pro") {
    bannerTitle = ProDIYBannerAndFooterCopies.titleForUpgradePro
    url = undefined
    handleOnClick = onClick
  }

  return (
    <div styleName="pro-diy-footer">
      <div>{bannerTitle}</div>
      <div styleName="button-container">
        <a
          className="button-tertiary button-on-color button-outlined"
          role="button"
          onClick={onHide}
        >
          Maybe later
        </a>
        <a
          data-turbolinks="false"
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "get_pro_cta",
            location_type: "diy_composer",
          })}
          className="button-tertiary button-on-color"
          href={url}
          onClick={handleOnClick}
        >
          {buttonLabel}
        </a>
      </div>
    </div>
  )
}

ProDiyFooter.propTypes = {
  cookieName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  urls: PropTypes.shape({
    newProSubscriptionUrl: PropTypes.string.isRequired,
  }).isRequired,
  userTier: PropTypes.oneOf(["free", "intermediate_pro"]).isRequired,
}

export default ProDiyFooter
